var map = {
	"./en/btn_9_1.png": "LTtW",
	"./es/btn_9_1.png": "lGk0",
	"./pt/btn_9_1.png": "8BdN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wp/G";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_9_1\.png$
// module id = Wp/G
// module chunks = 0